import { render, staticRenderFns } from "./info-code.vue?vue&type=template&id=4310970e"
import script from "./info-code.vue?vue&type=script&lang=js"
export * from "./info-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports